import React, { useState } from 'react';
import { getMeds, getMedsHistory } from 'store/storeValtio';
import { lookupMed } from 'helpers/medicationHelpers';
import { exportData, isNullOrEmpty, validateEmail } from 'helpers/generalHelpers';
import Select from 'components/common/Select';
import moment from 'moment';
import { sendEmailText } from 'helpers/apiHelpers';
import HelpTitle from 'components/common/HelpTitle';

export default function ExportHistory() {
  const [errors, setErrors] = useState(null);
  const [selectedOption, setSelectedOption] = useState({value: "",label: "All Medications"});
  const history = getMedsHistory();

  console.log('ExportHistory');

  const meds = getMeds();
  var options = [{value: " ",label: " "}];
  meds.forEach((m, ix) => {
    const opt = {
      value: m.medicationId,
      label: m.name
    }
    options.push(opt);
  })
  options.sort((a,b)=>{
    if (a.label < b.label) { return -1; }
    if (a.label > b.label) { return 1; }
    return 0;
  })
  options[0].label = "All Medications";
  //console.log('options', options);

  function getHistoriesCSV() {
    var histList = [];
    const sov = selectedOption.value;
    //console.log('getHistoriesCSV', sov);
    history.forEach((h, ix) => {
      if (sov === '' || sov === h.medicationId ) {
        const medId = h.medicationId;
        const med = lookupMed(medId);
        const histItem = {
          name: med.name,
          quantity: h.quantity,
          date: h.date
        }
        histList.push(histItem);
      }
    });
    histList.sort((a,b)=>{
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      if (a.date < b.date) { return 1; }
      if (a.date > b.date) { return -1; }
      return 0;
    })
    //console.log('histList', histList);
    var csv = histList.map(function(h){
      const date = moment(h.date).format('yyyy-MM-DD HH:mm:ss');
      return `"${h.name}",${h.quantity},${date}`;
     })
     .join('\n') 

    let csvData = `"Medication","Quantity","Date Taken"\n` + csv;
    return csvData;
  }

  async function sendEmail() {
    let input = document.getElementById("sendEmail"); 
    if (!input || isNullOrEmpty(input.value)) {
      setErrors("Please enter an email address");
      return;
    }
    const email = input.value;
    if (!validateEmail(email)) {
      setErrors("Please enter a valid email address");
      return;
    }
    setErrors(null);
    const histList = getHistoriesCSV();
    const result = await sendEmailText(email, histList);
    input.value = '';
  }

  function selectionChanged(index) {
    const opt = options[index];
    console.log('selectionChanged', index, opt);

    setSelectedOption(opt);
  }

  function saveCSV() {
    const csvData = getHistoriesCSV();
    console.log(csvData);
    exportData(csvData, "history-list.csv");
  }

  return (
    <div className='w-full h-full pt-10 flex flex-col justify-normal items-center bg-blue-200'>
      <HelpTitle title="Export History Data" helpSubject="ExportHist" />

      {errors && (
        <div
          className='bg-red-100 rounded-lg py-2 px-10 mb-3 text-base text-red-700'
          role='alert'
        >
          {errors}
        </div>
      )}

      <div className='flex flex-col justify-normal items-center text-xl w-8/12 h-full'>
        <div className='w-full mb-4'>
          <div className='font-semibold'>
            Select medications
          </div>
          <Select
            className='border-2 border-black rounded-md'
            defaultValue={options[0]}
            onChange={(e) => selectionChanged(e)}
            options={options}
          />
        </div>
        <button
          className='rawBtn w-full h-10 bg-blue-400'
          onClick={() => saveCSV()}
        >
          Save History CSV
        </button>
        <div className='rawBtn flex flex-col justify-normal items-center w-full mt-4 p-4 bg-blue-400 hover:cursor'>
          <div>
            Email Medication List
          </div>
          <div className='min-w-full m-4'>
            <input
              className='formText'
              id='sendEmail'
              name='sendEmail'
              type='email'
              placeholder='email address'
            />
          </div>
          <button className='okBtn' onClick={sendEmail}>Send</button>
        </div>
      </div>
    </div>
);
}
